export const LOAD_FEATURE_FLAGS_DATA = 'featureFlags/LOAD_FEATURE_FLAGS_DATA';
export const SET_FEATURE_FLAGS_DATA = 'featureFlags/SET_FEATURE_FLAGS_DATA';
export const SET_FEATURE_FLAGS_STATUS = 'featureFlags/SET_FEATURE_FLAGS_STATUS';
